import { gql } from 'graphql-request';
import { getGraphQLQueryClient } from './query-client';
import {
  AvatarFrame,
  GamificationProfile,
  Nullable,
  UserTitle,
  UserWithToken,
  WithData,
} from '@ygoargentina/sdk/api/api.types';

const GAMIFICATION_PROFILE_FIELDS = gql`
  fragment GamificationProfileFields on GamificationProfile {
    level
    totalXp
    activeTitle
    activeAvatarFrame
    unlockedTitles
    unlockedFrames
  }
`;

const USER_TITLE_FIELDS = gql`
  fragment UserTitleFields on UserTitle {
    id
    userId
    title
    isActive
    unlockedAt
  }
`;

export const getMyGamificationProfile = async (user: UserWithToken) =>
  getGraphQLQueryClient(user).request<WithData<GamificationProfile>>(
    gql`
      ${GAMIFICATION_PROFILE_FIELDS}
      query myGamificationProfile {
        data: myGamificationProfile {
          ...GamificationProfileFields
        }
      }
    `
  );

export const getUserGamificationProfile = async (
  user: Nullable<UserWithToken>,
  userId: number
) =>
  getGraphQLQueryClient(user).request<WithData<GamificationProfile>>(
    gql`
      ${GAMIFICATION_PROFILE_FIELDS}
      query userGamificationProfile($userId: Int!) {
        data: userGamificationProfile(userId: $userId) {
          ...GamificationProfileFields
        }
      }
    `,
    { userId }
  );

export const getMyUserTitles = async (user: UserWithToken) =>
  getGraphQLQueryClient(user).request<WithData<UserTitle[]>>(
    gql`
      ${USER_TITLE_FIELDS}
      query myUserTitles {
        data: myUserTitles {
          ...UserTitleFields
        }
      }
    `
  );

export const setActiveTitle = async (
  user: UserWithToken,
  title: string | null
) =>
  getGraphQLQueryClient(user).request<WithData<UserTitle | null>>(
    gql`
      ${USER_TITLE_FIELDS}
      mutation setActiveTitle($title: String) {
        data: setActiveTitle(title: $title) {
          ...UserTitleFields
        }
      }
    `,
    { title }
  );

export const setActiveAvatarFrame = async (
  user: UserWithToken,
  frame: AvatarFrame
) =>
  getGraphQLQueryClient(user).request<WithData<GamificationProfile>>(
    gql`
      ${GAMIFICATION_PROFILE_FIELDS}
      mutation setActiveAvatarFrame($frame: AvatarFrame!) {
        data: setActiveAvatarFrame(frame: $frame) {
          ...GamificationProfileFields
        }
      }
    `,
    { frame }
  );

export const grantUserTitle = async (
  user: UserWithToken,
  userId: number,
  title: string
) =>
  getGraphQLQueryClient(user).request<WithData<UserTitle>>(
    gql`
      ${USER_TITLE_FIELDS}
      mutation grantUserTitle($userId: Int!, $title: String!) {
        data: grantUserTitle(userId: $userId, title: $title) {
          ...UserTitleFields
        }
      }
    `,
    { userId, title }
  );
